
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';

import FAQ from './FAQ';
import UsePageTracking from '../components/usePageTracking';


function Ertigaonrentinpune() {



    const cardData =
    {
        keyword: 'Ertiga on Rent in Pune',
        heading: 'Morya Cabs: Ertiga on Rent in Pune',
        headingDescription: 'Looking for an Ertiga on rent in Pune? Morya Cabs offers a reliable and budget-friendly solution for all your travel needs. Whether you are planning a family outing, a corporate trip, or a weekend getaway with friends, the 7-seater Maruti Suzuki Ertiga is the perfect vehicle for a smooth and comfortable journey. Equipped with modern features, ample luggage space, and exceptional fuel efficiency, the Ertiga rental in Pune ensures a hassle-free travel experience',

        top: 'Top Destinations for Ertiga Rental in Pune:',

"topPlaces": [
    {
        "title": "Shirdi",
        "description": "A renowned pilgrimage destination, Shirdi is home to the sacred Sai Baba Temple, attracting thousands of devotees every year. Located just a few hours from Pune, it is an ideal spiritual retreat. Renting an Ertiga ensures a smooth and comfortable journey for families and groups, providing ample space for passengers and luggage while enjoying a hassle-free ride to this holy town."
    },
    {
        "title": "Lavasa",
        "description": "Lavasa, a charming hill station near Pune, is known for its scenic landscapes, lakeside promenade, and European-inspired architecture. It’s a perfect weekend getaway for nature lovers and adventure seekers. With an Ertiga rental, your group can enjoy a relaxed and spacious ride through the winding roads leading to this beautiful destination."
    },
    {
        "title": "Mahabaleshwar",
        "description": "Famous for its lush greenery, breathtaking viewpoints, and strawberry farms, Mahabaleshwar is one of the most sought-after hill stations near Pune. Whether you want to explore Arthur’s Seat, Venna Lake, or Elephant’s Head Point, the Ertiga offers ample legroom and comfort for a memorable group journey to this serene retreat."
    },
    {
        "title": "Matheran",
        "description": "Matheran, India’s only eco-sensitive hill station, offers a pollution-free environment with stunning views and lush forests. Known for its toy train and horse rides, it’s an ideal spot for a peaceful getaway. An Ertiga rental ensures that your group reaches the base of Matheran comfortably, from where you can enjoy a scenic trek or toy train ride to the hilltop."
    },
    {
        "title": "Khandala & Lonavala",
        "description": "Lonavala and Khandala are twin hill stations near Pune, famous for their waterfalls, caves, and scenic beauty. Whether you’re visiting Tiger’s Leap, Bhushi Dam, or Karla Caves, traveling in an Ertiga ensures a comfortable and spacious ride. It’s the perfect vehicle for family trips, corporate outings, or weekend getaways."
    },
    {
        "title": "Alibaug",
        "description": "A popular coastal town near Pune, Alibaug is known for its serene beaches, forts, and water sports. Whether you plan to relax at Alibaug Beach, visit the historic Kolaba Fort, or enjoy thrilling activities, renting an Ertiga ensures a smooth and comfortable trip, providing ample space for passengers and luggage."
    },
    {
        "title": "Sinhagad Fort",
        "description": "Sinhagad Fort, a historic gem near Pune, is a paradise for history buffs and trekking enthusiasts. The fort offers breathtaking views and a glimpse into Maratha history. An Ertiga rental makes the journey to this iconic destination more enjoyable, ensuring a comfortable ride for groups planning to explore its scenic beauty and historical significance."
    },
    {
        "title": "Panchgani",
        "description": "Panchgani, a serene hill station surrounded by five beautiful hills, is known for its pleasant climate, strawberry farms, and breathtaking viewpoints like Table Land. Whether you’re traveling with family or friends, the Ertiga provides a smooth and spacious ride, making your journey to this charming destination more relaxing."
    },
    {
        "title": "Tungabhadra Dam",
        "description": "If you’re looking for a peaceful retreat amidst nature, Tungabhadra Dam is an excellent choice. The dam offers stunning views of the reservoir and surrounding landscapes, making it a perfect getaway for nature lovers. Renting an Ertiga ensures a relaxed and comfortable journey for your group to this tranquil destination."
    },
    {
        "title": "Bhandardara",
        "description": "Bhandardara is a hidden gem in Maharashtra, known for its picturesque lakes, lush greenery, and breathtaking waterfalls like Randha Falls. It’s a great spot for camping, boating, and nature exploration. An Ertiga rental allows your group to travel comfortably and enjoy the scenic beauty of this peaceful destination."
    }
],


"services": [
    {
      "name": "Ertiga on Rent Pune",
      "description": "Morya Cab offers Ertiga on rent in Pune for a comfortable and spacious travel experience. Whether you are traveling locally or for an outstation trip, the Ertiga provides the perfect combination of comfort and affordability."
    },
    {
      "name": "Ertiga Car on Rent in Pune",
      "description": "Looking for an Ertiga car on rent in Pune? Morya Cab provides well-maintained and reliable Ertiga cars for rent to make your journey comfortable and stress-free."
    },
    {
      "name": "Ertiga CNG on Rent in Pune",
      "description": "Morya Cab offers Ertiga CNG on rent in Pune for those seeking an eco-friendly and cost-effective travel option. Enjoy a smooth ride with the added benefit of fuel efficiency."
    },
    {
      "name": "Ertiga Rent in Pune",
      "description": "Rent an Ertiga in Pune with Morya Cab for a comfortable and affordable travel experience. Our competitive pricing ensures you get the best value for your journey."
    },
    {
      "name": "Ertiga Rent Per Km in Pune",
      "description": "Morya Cab offers flexible Ertiga rent per km in Pune. We ensure transparent pricing with no hidden charges, so you can enjoy your trip with complete peace of mind."
    },
    {
      "name": "Ertiga Rental Pune",
      "description": "For your travel needs, Morya Cab offers Ertiga rental services in Pune. Enjoy the spacious comfort of the Ertiga for your family or group trips."
    },
    {
      "name": "Maruti Ertiga on Rent in Pune",
      "description": "Morya Cab provides Maruti Ertiga on rent in Pune, perfect for both short trips and long-distance travel. Book your ride today for a hassle-free journey."
    },
    {
      "name": "Pune to Shirdi Ertiga on Rent",
      "description": "Planning a trip from Pune to Shirdi? Rent an Ertiga from Morya Cab and enjoy a smooth, comfortable ride. Our drivers ensure that your trip is safe and pleasant."
    },
    {
      "name": "Pune to Shirdi Cab Package",
      "description": "Morya Cab offers convenient Pune to Shirdi cab packages, including Ertiga for a comfortable journey. Book your trip with us for an affordable and reliable travel experience."
    },
    {
      "name": "Pune Airport to Shirdi Ertiga Cab Package",
      "description": "Traveling from Pune Airport to Shirdi? Morya Cab offers an Ertiga cab package for a smooth and comfortable ride, ensuring you reach Shirdi in comfort."
    },
    {
      "name": "Pune to Mahabaleshwar Ertiga Cab",
      "description": "Morya Cab offers Ertiga cabs for your Pune to Mahabaleshwar journey. Travel in style with a spacious and comfortable vehicle for your family or group trip."
    },
    {
      "name": "Pune to Kolhapur Ertiga Cab",
      "description": "For a peaceful and enjoyable journey from Pune to Kolhapur, rent an Ertiga from Morya Cab. Our professional drivers will ensure a smooth ride, making your trip hassle-free."
    },
    {
      "name": "Pune to Mumbai Ertiga Cab Booking",
      "description": "Morya Cab provides Ertiga cabs for booking from Pune to Mumbai. Travel comfortably with your group or family in our well-maintained vehicles."
    },
    {
      "name": "Pune to Lonavala Ertiga Cab Booking",
      "description": "For a quick getaway from Pune to Lonavala, book an Ertiga cab with Morya Cab. We offer competitive pricing and a comfortable travel experience."
    },
    {
      "name": "Pune to Goa Ertiga Cab",
      "description": "Looking to travel from Pune to Goa? Morya Cab offers Ertiga cabs for a comfortable ride, ensuring you enjoy your trip with ample space and convenience."
    },
    {
      "name": "Pune to Mumbai Airport Ertiga Cab",
      "description": "Morya Cab offers Ertiga cabs for a seamless ride from Pune to Mumbai Airport. Book your Ertiga for a stress-free airport transfer."
    },
    {
      "name": "Pune to Ashtavinayak Darshan Ertiga Cab",
      "description": "For your Ashtavinayak Darshan trip, rent an Ertiga with Morya Cab. Our well-maintained vehicles and experienced drivers will ensure a smooth and divine journey."
    },
    {
      "name": "Pune to Shani Shingnapur Ertiga Cab",
      "description": "Planning a trip to Shani Shingnapur from Pune? Rent an Ertiga with Morya Cab for a comfortable and enjoyable ride. We offer flexible packages for your convenience."
    },
    {
      "name": "Pune to Outstation Ertiga Cab",
      "description": "Morya Cab offers Ertiga cabs for outstation travel. Whether it's a long-distance trip or a weekend getaway, we provide comfortable and affordable Ertiga rentals."
    },
    {
      "name": "Pune to Solapur Ertiga Cab",
      "description": "Travel comfortably from Pune to Solapur with an Ertiga cab from Morya Cab. Our professional drivers ensure a smooth and relaxing journey to your destination."
    }
  ],


  tableData: [
    ["Ertiga on Rent Pune", "-Ertiga car on rent in Pune"],
    ["Ertiga CNG on Rent in Pune", "-Ertiga rent in Pune"],
    ["Ertiga Rent Per KM in Pune", "-Ertiga rental Pune"],
    ["Maruti Ertiga on Rent in Pune", "-Pune to Shirdi Ertiga on rent"],
    ["Pune to Shirdi Cab Package", "-Pune Airport to Shirdi Ertiga Cab Package"],
    ["Pune to Mahabaleshwar Ertiga Cab", "-Pune to Kolhapur Ertiga Cab"],
    ["Pune to Mumbai Ertiga Cab Booking", "-Pune to Lonavala Ertiga Cab Booking"],
    ["Pune to Goa Ertiga Cab", "-Pune to Mumbai Airport Ertiga Cab"],
    ["Pune to Ashtavinayak Darshan Ertiga Cab", "-Pune to Shani Shingnapur Ertiga Cab"],
    ["Pune to Outstation Ertiga Cab", "-Pune to Solapur Ertiga Cab"]
],

whychoose: [
    {
        "WhyChooseheading": "Reliable and On-Time Service",
        "WhyChoosedescription": "At Morya Cab, we value your time. Whether you're heading for a family outing, business trip, or a sightseeing tour, our Ertiga rental ensures timely pickups and drop-offs, providing a stress-free and smooth travel experience."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "The Ertiga is the perfect vehicle for group travel. With comfortable seating for up to 7 passengers, ample legroom, and air-conditioning, it ensures a pleasant ride for your entire family or group."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our drivers are well-trained, courteous, and experienced in handling long-distance travel, ensuring your journey is smooth, safe, and hassle-free. They are familiar with the best routes in Pune and beyond."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Morya Cab offers competitive pricing for Ertiga rentals. We believe in full transparency with no hidden charges, providing you with a clear breakdown of costs so you can plan your budget accordingly."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Journey",
        "WhyChoosedescription": "The safety of our passengers is a top priority. Our Ertiga vehicles are equipped with modern safety features such as airbags, seat belts, and GPS tracking, ensuring a secure and comfortable ride throughout your journey."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "Morya Cab operates around the clock, offering 24/7 service. Whether it’s an early morning pickup or a late-night return, we are always ready to assist you with your travel needs."
    },
    {
        "WhyChooseheading": "Hassle-Free Booking Process",
        "WhyChoosedescription": "Booking an Ertiga on rent with Morya Cab is quick and easy. You can book online via our website or app, or you can contact our customer service team for personalized assistance."
    },
    {
        "WhyChooseheading": "Customized Travel Packages",
        "WhyChoosedescription": "Whether it's a family vacation, corporate trip, or a weekend getaway, we offer customized travel packages with the Ertiga, ensuring your trip is tailored to your specific needs."
    }
]








    }

    const faqData = [
        {
          question: "How can I book an Ertiga on rent with Morya Cab?",
          answer: "Booking is easy! You can reserve your Ertiga online through our website or app, or you can contact our customer service team for any assistance you need."
        },
        {
          question: "How many passengers can the Ertiga accommodate?",
          answer: "The Ertiga comfortably accommodates up to 7 passengers, making it an ideal choice for family outings or group travel."
        },
        {
          question: "Are the drivers experienced for long-distance travel?",
          answer: "Yes, all our drivers are experienced in handling long-distance trips and are familiar with the best routes, ensuring a safe and efficient journey."
        },
        {
          question: "What types of vehicles are available for rent besides Ertiga?",
          answer: "In addition to the Ertiga, we offer a variety of vehicles including sedans, SUVs, mini buses, and premium cars for various group sizes and needs."
        },
        {
          question: "How do I pay for my Ertiga rental?",
          answer: "We offer flexible payment options including cash, credit/debit cards, and online payments through our app, ensuring convenience for you."
        },
        {
          question: "Can I book a round trip with an Ertiga?",
          answer: "Yes, round trips are available. Just provide us with your return details, and we’ll take care of the rest."
        },
        {
          question: "Are there any extra charges for waiting or detours?",
          answer: "Any extra charges, like waiting time or detours, will be clearly communicated to you upfront, so there are no surprises."
        },
        {
          question: "Can I hire an Ertiga for sightseeing in Pune?",
          answer: "Yes, we offer Ertiga rentals for sightseeing tours in and around Pune. Explore the city’s major attractions comfortably with our experienced drivers."
        },
        {
          question: "What is the luggage allowance for an Ertiga?",
          answer: "The Ertiga offers ample boot space for luggage. If you have more luggage or specific requirements, please let us know during booking, and we’ll make the necessary arrangements."
        },
        {
          question: "Is Morya Cab available for corporate travel with an Ertiga?",
          answer: "Yes, we provide corporate travel services, offering an excellent choice for business trips, meetings, or team outings with the Ertiga."
        }
      ];
      
      const testimonialData = [
        {
          id: 1,
          name: 'Mr. Harsh Bansal',
          role: 'Traveler',
          review: "I rented an Ertiga for a family trip to Lonavala, and the experience was amazing! The vehicle was comfortable, spacious, and the driver was courteous and professional. Highly recommend Morya Cab!",
          rating: 5,
          quoteIcon: '/img/icon/testi-quote.svg',
        },
        {
          id: 2,
          name: 'Ms. Aditi Verma',
          role: 'Traveler',
          review: "We used Morya Cab for a group outing, and the Ertiga was perfect for our needs. Comfortable ride, great service, and the driver was very professional. I’ll definitely be using them again!",
          rating: 5,
          quoteIcon: '/img/icon/testi-quote.svg',
        }
      ];
      
      
      
      
      
      
      







    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9371304510",
            "+91 8379975860",



        ],
        email: "booking@moryacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Shirdi Taxi",
            link: "/Pune-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Bhimashankar Taxi",
            link: "/Pune-to-Bhimashankar-Taxi"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai Taxi",
            link: "/Pune-to-Mumbai-Taxi"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala Taxi",
            link: "/Pune-to-Lonavala-Taxi"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mahabaleshwar Taxi",
            link: "/Pune-to-Mahabaleshwar-Taxi"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Aurangabad Taxi",
            link: "/Pune-to-Aurangabad-Taxi"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Nashik-Trimbakeshwar Taxi",
            link: "/Pune-to-Nashik-Trimbakeshwar-Taxi"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Pune Car Rental Services",
            link: "/Pune-Car-Rental-Services"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Ashtavinayak Taxi",
            link: "/Pune-to-Ashtavinayak-Taxi"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Goa Taxi",
            link: "/Pune-to-Goa-Taxi"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Solapur Taxi",
            link: "/Pune-to-Solapur-Taxi"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Hyderabad Cab",
            link: "/Pune-to-Hyderabad-Cab"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Kolhapur Taxi",
            link: "/Pune-to-Kolhapur-Taxi"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Bangalore Taxi",
            link: "/Pune-to-Bangalore-Taxi"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Indore Taxi",
            link: "/Pune-to-Indore-Taxi"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai to Shirdi Taxi",
            link: "/Mumbai-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Borivali to Pune Taxi Service",
            link: "/Borivali-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Vasai to Pune Taxi Service",
            link: "/Vasai-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Dombivli to Pune Taxi Services",
            link: "/Dombivli-to-Pune-Taxi-Services"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Dadar to Shirdi Taxi Service",
            link: "/Dadar-to-Shirdi-Taxi-Service"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Trimbakeshwar Taxi",
            link: "/Mumbai-to-Trimbakeshwar-Taxi"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Bhimashankar Taxi",
            link: "/Mumbai-to-Bhimashankar-Taxi"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai Central to Pune Taxi",
            link: "/Mumbai-Central-to-Pune-Taxi"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Thane to Pune Taxi Service",
            link: "/Thane-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Nashik Taxi",
            link: "/Mumbai-to-Nashik-Taxi"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Lonavala Taxi",
            link: "/Mumbai-to-Lonavala-Taxi"
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Mumbai Airport to Pune Taxi",
            link: "/Mumbai-Airport-to-Pune-Taxi"
        }
    ];


    const images = [
        { src: "/images/our-fleet/3.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/4.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/5.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/7.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/8.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/10.jpg", alt: "Image 1" },
       
    ];

  
// const productSchema = {
//   "@context": "https://schema.org",
//   "@type": "Product",
//   "name": "Ertiga on Rent in Pune",
//   "image": "https://moryacab.com/assets/images/ertiga-on-rent-in-pune.jpg",
//   "description": "Book Ertiga on rent in Pune with Morya Cab. Spacious and comfortable AC Ertiga available with professional drivers for family trips, airport transfers, corporate travel, weddings, and outstation journeys. Affordable fares, clean vehicles, and reliable service for budget-friendly travel.",
//   "brand": {
//     "@type": "Brand",
//     "name": "Morya Cab"
//   },
//   "aggregateRating": {
//     "@type": "AggregateRating",
//     "bestRating": "5",
//     "worstRating": "1",
//     "ratingValue": "4.9",
//     "ratingCount": "8126"
//   },
//   "offers": {
//     "@type": "Offer",
//     "priceCurrency": "INR",
//     "price": "1800",
//     "availability": "https://schema.org/InStock",
//     "url": "https://moryacab.com/ertiga-on-rent-in-pune"
//   }
// };






    
const ertigaRentPuneSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Ertiga on Rent in Pune",
  "image": "https://moryacab.com/assets/images/ertiga-on-rent-pune.jpg",
  "description": "Book Ertiga on rent in Pune with Morya Cabs. Comfortable 6/7-seater AC vehicle, ideal for family trips, airport transfers, and outstation travel. Affordable fares with professional drivers and 24/7 support.",
  "brand": {
    "@type": "Brand",
    "name": "Morya Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "2850",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "16",
    "availability": "https://schema.org/InStock",
    "url": "https://moryacab.com/ertiga-on-rent-pune"
  }
};




    return (
        <div>
<UsePageTracking/>

<Helmet>
  <title>Ertiga on Rent in Pune | Affordable 7-Seater SUV | Morya Cabs</title>
  <meta
    name="description"
    content="Book Ertiga on rent in Pune with Morya Cabs. Comfortable 6/7-seater AC vehicle, ideal for family trips, airport transfers, and outstation travel. Affordable fares with professional drivers and 24/7 support."
  />
  <meta
    name="keywords"
    content="Ertiga on Rent Pune, Book Ertiga Pune, 7 Seater Car Rental Pune, SUV Rental Pune, Outstation Cab Pune, Morya Cabs Ertiga Booking, Airport Transfer Ertiga Pune, AC Ertiga Hire Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(ertigaRentPuneSchema)}
  </script>
</Helmet>


{/* <Helmet>
  <title>Ertiga on Rent in Pune | Family & Outstation Cab – Morya Cab</title>
  <meta
    name="description"
    content="Hire Ertiga on rent in Pune with Morya Cab. Spacious 7-seater AC car with verified drivers for family trips, corporate travel, weddings & outstation cab bookings at affordable fares."
  />
  <meta
    name="keywords"
    content="Ertiga on rent in Pune, Ertiga cab Pune, Ertiga car rental Pune, Hire Ertiga in Pune, Ertiga taxi Pune, Ertiga for wedding Pune, Ertiga for airport transfer Pune, Ertiga outstation cab Pune, Pune to Mumbai Ertiga cab, Morya Cab Ertiga Pune"
  />
  <link rel="canonical" href="https://moryacab.com/ertiga-on-rent-in-pune" />
  <meta property="og:type" content="website" />
  <meta property="og:title" content="Ertiga on Rent in Pune | Family & Outstation Cab – Morya Cab" />
  <meta property="og:description" content="Book Ertiga rental in Pune with Morya Cab. Affordable fares, clean AC cars, verified drivers & reliable service for family, airport & outstation trips." />
  <meta property="og:url" content="https://moryacab.com/ertiga-on-rent-in-pune" />
  <meta property="og:image" content="https://moryacab.com/assets/images/ertiga-on-rent-in-pune.jpg" />
  <meta name="twitter:card" content="summary_large_image" />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet> 

// 5:3
*/}


            <div className="breadcumb-wrapper" style={{ backgroundImage: 'url(/img/bg/breadcumb-bg.jpg)' }}>
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className='text-white'>{cardData.keyword}</h1>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/76.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                               style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Morya Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                                            {Images.map((e) => {
    return (
        <div className="box1" key={e.text}>
            <a
                href={e.link} // Use the separate link for each item
                className="d-flex justify-content-around align-items-center"
            >
                <div className="b1">
                    <img src={e.place} alt={e.text} />
                </div>
                <div className="b2">
                    <a href={e.link} className="px-3 colorr">{e.text}</a>
                </div>
            </a>
        </div>
    );
})}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #0AB4A9',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#0AB4A9' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 9371304510" className="d-block  text-white">+91 9371304510</a>
                                                <a href="tel:+91 8379975860" className="d-block  text-white">+91 8379975860</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#0AB4A9' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@moryacab.com" className=" text-white d-block">
                                                    booking@moryacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#0AB4A9' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Morya Cab<br />
                                                    Gat no. 763 Jai Ganesh Niwas Flat no. 1 Lokhande Wasti Chimbali Pune, Maharashtra 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Ertigaonrentinpune;